import { z } from 'zod';

import { zFiltersArray } from 'helpers/router';

/** Sort columns supported by the potential guests API (server-side sorting). */
export const potentialGuestsSortColumnSchema = z.enum([
  'advisor_name',
  'created',
  'email',
  'events_attended_count',
  'events_invited_count',
  'last_event_date',
  'name',
  'source_type',
  'tier',
  'underrepresented',
  'warm',
]);

/**
 * URL search params for potential-guests table UIs (add-participants flow and
 * global Participants browse).
 */
export const potentialGuestsListSearchSchema = z.object({
  companyType: zFiltersArray(),
  advisor: zFiltersArray(),
  company: zFiltersArray(),
  event: zFiltersArray(),
  tier: zFiltersArray(),
  candidateType: zFiltersArray(),
  pathway: zFiltersArray(),
  lastEvent: zFiltersArray(),
  industryExpertise: zFiltersArray(),
  functionExpertise: zFiltersArray(),
  operatingHighlights: zFiltersArray(),
  interestRoleOperating: zFiltersArray(),
  interestRoleBoard: zFiltersArray(),
  filtersDialog: z
    .enum([
      'companyType',
      'advisor',
      'company',
      'event',
      'tier',
      'candidateType',
      'pathway',
      'lastEvent',
      'industryExpertise',
      'functionExpertise',
      'operatingHighlights',
      'interestRoleOperating',
      'interestRoleBoard',
    ])
    .optional()
    .catch(undefined),
  order: z.enum(['asc', 'desc']).optional().catch('asc').default('asc'),
  sort: z.preprocess(
    (val) => (val === '' || val == null ? undefined : val),
    potentialGuestsSortColumnSchema.optional(),
  ),
});

export type PotentialGuestsListSearchSchema = z.infer<
  typeof potentialGuestsListSearchSchema
>;

/** Default URL search for routes using `potentialGuestsListSearchSchema` (e.g. navigation to `/events/participants`). */
export const emptyPotentialGuestsListSearch: PotentialGuestsListSearchSchema =
  potentialGuestsListSearchSchema.parse({});
